import { Box, CardMedia, Typography } from '@mui/material';
import GroupAssessment from './../../../assets/group_assessment.svg';

export const EmptyPlaceholder = ({
  title,
  message,
}: {
  title: string;
  message: string;
}) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <CardMedia
        image={GroupAssessment}
        sx={{ minHeight: '267px', minWidth: '400px' }}
      />
      <Typography variant="body2" className="text-center font-bold leading-6">
        {title}
      </Typography>
      <Typography variant="body2" className="text-center">
        {message}
      </Typography>
    </Box>
  );
};
